import { createAction } from '@reduxjs/toolkit';

import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';

import type {
  KbbVehicleSubmittingObject,
  ManualVehicleSubmittingObject,
  UpdateVehicleAccountFieldsSubmittingObject,
} from './vehicleTypes';

const saveManualVehiclePayloadCreator = getPayloadCreator<ManualVehicleSubmittingObject>();
const saveKbbVehiclePayloadCreator = getPayloadCreator<KbbVehicleSubmittingObject>();
const updateVehicleAccountFieldsPayloadCreator = getPayloadCreator<UpdateVehicleAccountFieldsSubmittingObject>();

export const saveManualVehicleAccount = createAction('SAVE_MANUAL_VEHICLE_ACCOUNT', saveManualVehiclePayloadCreator);

export const saveKbbVehicleAccount = createAction('SAVE_KBB_VEHICLE_ACCOUNT', saveKbbVehiclePayloadCreator);

export const updateVehicleAccountFields = createAction(
  'UPDATE_VEHICLE_ACCOUNT_FIELDS',
  updateVehicleAccountFieldsPayloadCreator,
);
